import {configTables} from "../../../global/configTables.js";
import {common} from "../../../global/common.js";
import {notifications} from "../../../global/notifications.js";

/** Enrollment search requires a plan category (modal or toolbar) before calling ProviderSearch. */
export const enrollmentPlanCategoryMixin = {
	methods: {
		getEnrollmentPlanCategoryIds() {
			const routeCategoryId = this.$route.query.planCategoryId;
			if (routeCategoryId === undefined || routeCategoryId === null || routeCategoryId === '') {
				return [];
			}
			const id = Number(routeCategoryId);
			return Number.isNaN(id) ? [] : [id];
		},

		mergeEnrollmentSearchResults(existing, incoming) {
			const byId = new Map();
			[...(existing || []), ...(incoming || [])].forEach((row) => {
				const id = row.providerEntityId;
				if (id == null) {
					return;
				}
				const current = byId.get(id);
				if (!current || row.distance < current.distance) {
					byId.set(id, row);
				}
			});
			return [...byId.values()].sort((a, b) => {
				if (a.preferred && !b.preferred) {
					return -1;
				}
				if (!a.preferred && b.preferred) {
					return 1;
				}
				return a.distance - b.distance;
			});
		},

		buildEnrollmentSearchUrl(baseUrl, criteria, planCategoryId) {
			let searchUrl = baseUrl;
			searchUrl = common.appendUrlParameter(searchUrl, 'designationId', criteria.designationId);
			searchUrl = common.appendUrlParameter(searchUrl, 'isAccepting', criteria.onlyAcceptingNewPatients);
			searchUrl = common.appendUrlParameter(searchUrl, 'physicianName', criteria.physicianName);
			searchUrl = common.appendUrlParameter(searchUrl, 'networkId', criteria.networkId);
			searchUrl = common.appendUrlParameter(searchUrl, 'planCategoryId', planCategoryId);
			return searchUrl;
		},

		async searchEnrollmentPhysicians() {
			const radiusOptions = await configTables.getSearchRadiusOptions();
			const distance = radiusOptions.find((x) => x.id === this.searchCriteria.radiusId).value;
			const criteria = {...this.searchCriteria, distance};
			const categoryIds = this.getEnrollmentPlanCategoryIds();

			this.$store.commit('SET_SEARCHING_FLAG', true);
			this.$store.commit('SET_PAGE', 1);
			this.$store.commit('SET_PHYSICIAN_SEARCH_RESULTS', []);
			this.$store.commit('SET_SEARCH_CRITERIA', criteria);

			if (categoryIds.length === 0) {
				this.$store.commit('SET_SEARCHING_FLAG', false);
				return;
			}

			let merged = [];
			for (const planCategoryId of categoryIds) {
				const searchUrl = this.buildEnrollmentSearchUrl(this.generateBaseUrl(), criteria, planCategoryId);
				const results = await $.ajax({type: 'GET', global: false, url: searchUrl});
				merged = this.mergeEnrollmentSearchResults(merged, results);
			}

			this.$store.commit('SET_PHYSICIAN_SEARCH_RESULTS', merged);
			if (merged.length === 0) {
				notifications.show({
					title: 'No results found',
					message: 'We were unable to find any plans under the current search criteria'
				}, common.ACRESSA_NOTIFICATIONS.ERROR);
			}
			this.$store.commit('SET_SEARCHING_FLAG', false);
		}
	}
};
